import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {AuditServiceService} from "../audit-service.service";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {Content, Page} from "../audit.models";
import {Observable, Subject} from "rxjs";
import {debounceTime, distinctUntilChanged, map, switchMap} from "rxjs/operators";
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";
import {UntypedFormControl} from "@angular/forms";

@Component({
  selector: 'app-audit-sms',
  templateUrl: './audit-sms.component.html',
  styleUrls: ['./audit-sms.component.css']
})
export class AuditSmsComponent implements OnInit, AfterViewInit {

  auditsPage: Page<Content> = new Page<Content>();
  displayedColumns: string[] = [ 'receivedPhoneNumber','provider',  'contentSms', 'transactionId','status', 'action'];
  dataSource: MatTableDataSource<Content> = new MatTableDataSource<Content>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  page = 0;
  size = 10;
  loading = true;

  searchControl: UntypedFormControl = new UntypedFormControl();
  auditSms: Content[] = []
  totalElements: number = 0;
  searchTerms = new Subject<string>();
  auditSms$: Observable<Content[]>;

  requestParam = {
    search: '',
    size: 20,
    page: 0
  }
   search='';

  constructor(private auditService: AuditServiceService) {
  }

  ngOnInit(): void {
    this.fetchData();

    /*  this.auditSms$ = this.searchTerms.pipe(
        // {...."ab"..."abz"."ab"...."abc"......}
        debounceTime(300),
        // {......"ab"...."ab"...."abc"......}
        distinctUntilChanged(),
        // {......"ab"..........."abc"......}
        switchMap((term) => this.auditService.getAuditSMS(this.requestParam.search = term).pipe(
          map(value => value.content)
        ))
      );*/
    // this.getAllSms({});


  }


/*  nextPage(event: PageEvent) {
    // const request = {};
    this.requestParam.page = event.pageIndex;
    this.requestParam.size = event.pageSize;
    this.getAllSms(this.requestParam);
  }*/

/*

  private getAllSms(request: any) {
    console.log('call get sms')
    /!* // this.auditSms$ =
       this.auditService.getAuditSMS(this.requestParam).pipe(
       map(value => {
         this.totalElements = value.totalElements;
         console.log("value", value)
         this.auditSms = value.content;
         return value.content;
       })
     )*!/
    this.auditService.getAuditSMS(this.requestParam).subscribe(data => {
      this.auditSms = data.content;
      this.totalElements = data.totalElements;
      this.dataSource = new MatTableDataSource(data.content);
      console.log(data)
    })
  }
*/

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  /* applyFilter(event: Event) {
     const filterValue = (event.target as HTMLInputElement).value;
     this.dataSource.filter = filterValue.trim().toLowerCase();

     if (this.dataSource.paginator) {
       this.dataSource.paginator.firstPage();
     }
   }*/

  fetchData() {
    console.log("fetch Data...")
    this.loading = true;
    this.auditService.getAuditSms(this.search, this.page, this.size).subscribe(value => {
      this.auditsPage = value;
      this.loading = false;
      this.dataSource.data = this.auditsPage.content;
    }, error => console.error(error));
  }

  resentSms(transId){
    this.auditService.sentSms(transId).subscribe(data=>{
      console.log(data)
    })
  }

  setPage(event: PageEvent) {
    if (event.pageSize != this.size) {
      this.size = event.pageSize;
      this.page = 0;
    } else {
      this.page = event.pageIndex;
    }
    this.fetchData();
  }

  applyFilter(event: KeyboardEvent) {

    if (this.search.length >= 2) {
      this.page = 0;
      this.fetchData();
    }
    if(this.search.length===0){
      this.fetchData()
    }
  }

  // search(value: string) {
  //   this.searchTerms.next(value)
  //   this.searchTerms.pipe(
  //     // {...."ab"..."abz"."ab"...."abc"......}
  //     debounceTime(300),
  //     // {......"ab"...."ab"...."abc"......}
  //     distinctUntilChanged(),
  //     // {......"ab"..........."abc"......}
  //     switchMap((term) => this.auditService.getAuditSMS(this.requestParam.search = term).pipe(
  //       map(value => value.content)
  //     ))).subscribe(value1 => {
  //     console.log('value 1 ', value1)
  //   })
  // }
}
